import "@patternfly/patternfly/patternfly-addons.css";
import "@patternfly/react-core/dist/styles/base.css";

import { KeycloakProvider } from "@keycloak/keycloak-account-ui";
import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { environment } from "./environment";
import { i18n } from "./i18n";
import { routes } from "./routes";
import { Help } from "@keycloak/keycloak-ui-shared";
import { normalizeAccountConsoleUrl } from "./utils";


normalizeAccountConsoleUrl();

const router = createHashRouter(routes);

i18n.init().then(() => {
  ReactDOM.createRoot(document.getElementById("app")!).render(
    <React.StrictMode>
      <Help>
        <KeycloakProvider environment={environment}>
          <RouterProvider router={router} />
        </KeycloakProvider>
      </Help>
    </React.StrictMode>,
  );
});